/* eslint-disable import/no-extraneous-dependencies, react/prop-types */
import React from 'react'
import Visual from 'bam-node-evp/src/Visual'
import SavantModel from 'bam-node-evp/src/Models/SavantModel'

import LoadSchema from './Schema'

// import 'bam-node-evp/dist/styles.css'

export default function App({ data, player, options }) {
    const schema = LoadSchema(data, player, options)
    schema.showToolTip = true
    return <Visual data={SavantModel(schema, data)} chart={schema} />
}
